module.exports = __webpack_public_path__ + "static/media/14.80f3a17f.jpg";